import { combineReducers } from 'redux';
import item from './item';
import itemSkus from './item/skus';
import itemAvailability from './item/availability';
import packageAvailability from './package/availability';
import packageSkus from './package/skus';
import itemPackage from './package';
import tag from './tag';
import location from './location';
import locationZone from './location-zone';
import auditLog from './audit-log';
import auditLogSearchOption from './audit-log/search-option';
import inventoryExport from './export';
import components from './components';
import reports from './reports';
import options from './options';

export default combineReducers({
  components,
  item,
  itemSkus,
  itemAvailability,
  package: itemPackage,
  packageSkus,
  packageAvailability,
  tag,
  location,
  locationZone,
  auditLog,
  auditLogSearchOption,
  export: inventoryExport,
  reports,
  options
});
